import { render, staticRenderFns } from "./ChubuMap.vue?vue&type=template&id=bdcc6ee8"
import script from "./ChubuMap.vue?vue&type=script&lang=js"
export * from "./ChubuMap.vue?vue&type=script&lang=js"
import style0 from "./ChubuMap.vue?vue&type=style&index=0&id=bdcc6ee8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports